export default __webpack_public_path__ + "static/media/stock22.f245c18c.jpg";